import React from "react";
import Paper from "@material-ui/core/Paper";
import { ArgumentAxis, ValueAxis, Chart, LineSeries } from "@devexpress/dx-react-chart-material-ui";
import { ValueScale } from "@devexpress/dx-react-chart";
import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import { labelComponent } from "./chartsConfigs";

const styles = () =>
    createStyles({
        root: {
            flex: 1,
            height: "100%",
            minWidth: 320
        }
    });

const UsersPerMonth = ({
    classes,
    chartData,
    chartsWrapperHeight
}: WithStyles<typeof styles> & { chartData: any[]; chartsWrapperHeight: number }) => {
    return (
        <Paper className={classes.root}>
            <div style={{ margin: 10 }}>
                <Chart height={chartsWrapperHeight} data={chartData}>
                    <ValueScale name="count" />
                    <ArgumentAxis labelComponent={labelComponent} showGrid />
                    <ValueAxis scaleName="count" showGrid showLine showTicks />
                    <LineSeries name="Total Transactions" valueField="count" argumentField="month" scaleName="count" />
                </Chart>
            </div>
        </Paper>
    );
};

export default withStyles(styles)(UsersPerMonth);
